import api from "./api";

const diagnosisService = {};
const endpoint = "/diagnosis";

diagnosisService.getDiagnoses = function (filter) {
  return api.get(endpoint, { params: filter }).then(({ data }) => data);
};

/**
 * @method search
 * @description Busca diagnósticos CIE-10 por código o descripción
 * @param {string} query - Texto de búsqueda
 * @returns {Promise} Lista de diagnósticos coincidentes
 */
diagnosisService.search = function (query) {
  return api
    .get("/diagnosis/search", { params: { q: query } })
    .then(({ data }) => data);
};

export default diagnosisService;
